import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export default function InitialReportSectionTabs({ sections = [], activeKey, onChange, ariaLabel = 'Report information sets', idPrefix = 'report' }) {
    function handleKeyDown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + sections.length) % sections.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % sections.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = sections.length - 1;

        const nextSection = sections[nextIndex];
        if (!nextSection) return;
        onChange(nextSection.key);
        event.currentTarget.parentElement?.querySelectorAll('[role="tab"]')?.[nextIndex]?.focus();
    }

    return (
        <Box
            role="tablist"
            aria-label={ariaLabel}
            sx={{
                display: 'flex',
                gap: 0.5,
                p: 0.5,
                minWidth: 0,
                overflowX: 'auto',
                borderRadius: 1,
                backgroundColor: 'action.hover'
            }}
        >
            {sections.map((section, index) => {
                const selected = section.key === activeKey;
                return (
                    <Button
                        key={section.key}
                        id={`${idPrefix}-tab-${section.key}`}
                        role="tab"
                        aria-selected={selected}
                        aria-controls={`${idPrefix}-panel-${section.key}`}
                        tabIndex={selected ? 0 : -1}
                        variant={selected ? 'contained' : 'outlined'}
                        disableElevation
                        disableRipple
                        onClick={() => onChange(section.key)}
                        onKeyDown={(event) => handleKeyDown(event, index)}
                        sx={{
                            minWidth: 112,
                            minHeight: 42,
                            px: 1.25,
                            py: 0.75,
                            flex: sections.length <= 4 ? '1 1 0' : '0 0 auto',
                            borderRadius: 0.75,
                            textTransform: 'none',
                            alignItems: 'center',
                            borderColor: selected ? 'primary.main' : 'divider',
                            color: selected ? 'primary.contrastText' : 'text.primary',
                            backgroundColor: selected ? 'primary.main' : 'background.paper'
                        }}
                    >
                        <Box sx={{ width: '100%', minWidth: 0, textAlign: 'left' }}>
                            <Typography sx={{ fontSize: 12, lineHeight: 1.25, fontWeight: 850, overflowWrap: 'anywhere' }}>
                                {section.label}
                            </Typography>
                            {Number.isFinite(Number(section.count)) ? (
                                <Typography sx={{ mt: 0.2, fontSize: 10.5, lineHeight: 1.2, fontWeight: 750, opacity: selected ? 0.86 : 0.62 }}>
                                    {section.count} record{section.count === 1 ? '' : 's'}
                                </Typography>
                            ) : null}
                        </Box>
                    </Button>
                );
            })}
        </Box>
    );
}